(function () {
  function sortReviewsByDate(root) {
    var wall = root.querySelector('.nr-reviews__wall');
    if (!wall) return;

    Array.from(wall.querySelectorAll('[data-nr-review-card]'))
      .sort(function (a, b) {
        return (b.dataset.reviewDate || '').localeCompare(a.dataset.reviewDate || '');
      })
      .forEach(function (card) {
        wall.appendChild(card);
      });
  }

  function initLoadMore(root) {
    var button = root.querySelector('[data-nr-load-more]');
    var wall = root.querySelector('.nr-reviews__wall');
    if (!button || !wall) return;

    var batch = Number(root.dataset.batchSize || 4);
    var visible = batch;

    function getCards() {
      return wall.querySelectorAll('[data-nr-review-card]');
    }

    function update() {
      var cards = getCards();
      cards.forEach(function (card, index) {
        card.hidden = index >= visible;
      });
      button.hidden = visible >= cards.length;
    }

    button.addEventListener('click', function () {
      visible += batch;
      update();
    });

    update();
  }

  function initModal(root) {
    var modal = root.querySelector('[data-nr-modal]');
    if (!modal) return;
    var modalImage = modal.querySelector('[data-nr-modal-image]');
    var closeButton = modal.querySelector('[data-nr-modal-close]');

    function openModal(src) {
      modalImage.src = src;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modalImage.removeAttribute('src');
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-nr-open-modal]').forEach(function (node) {
      node.addEventListener('click', function () {
        openModal(node.dataset.nrOpenModalSrc || node.src);
      });
    });

    if (closeButton) closeButton.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });
  }

  document.querySelectorAll('[data-nr-reviews-root]').forEach(function (root) {
    if (root.dataset.nrReviewsInit) return;
    root.dataset.nrReviewsInit = 'true';
    sortReviewsByDate(root);
    initLoadMore(root);
    initModal(root);
  });
})();
